export default "<p class=\"sr-only wcag\" tabindex=\"0\">{{wcagService.wcagText}}</p>\n";